export default __webpack_public_path__ + "static/logo_zantana_x192-a752acb50619baddbff0c8232da7d6b9.png";